import { IPortfolioBondLocal } from '@/creditflowresearch/domain/vo/PortfolioMonitor/ICreatePortfolioFormState';

export const getBondName = ({
  primaryIssuerTicker = '',
  primaryIssuerName = '',
  dealSeriesName = '',
  trancheClass = '',
}) => (
  `${ primaryIssuerTicker || primaryIssuerName } ${ dealSeriesName } ${ trancheClass }`.trim()
);

export const mapBondsToOptions = (bonds?: IPortfolioBondLocal[] | null) => {
  if (!bonds || !Array.isArray(bonds)) {
    return [];
  }
  return bonds.map((bond) => ({ label: getBondName(bond), value: bond }));
};

export const getFormattedBond = (
    { dealViewId, primaryIssuerName, primaryIssuerTicker, dealSeriesName }: IPortfolioBondLocal,
) => ({
  viewId: dealViewId,
  primaryIssuer: {
    name: primaryIssuerName,
  },
  issuerTicker: primaryIssuerTicker,
  seriesName: dealSeriesName,
});
